var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{attrs:{"type":"is-light","closable":false}},[_c('h1',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('PORTAL.SAUDACOES'))),_c('b',[_vm._v(_vm._s(_vm.usuario.nomeCadastro))]),_vm._v(" !")]),_c('p',[_vm._v(_vm._s(_vm.$t('PORTAL.INSTRUCOES')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }